$(document).ready(function () {

    console.log('Loaded content');

    if($('.quantity__button')[0].parentElement.children[1].attributes[4].value == 0){
        $('.quantity__button')[0].parentElement.children[1].attributes[4].value = 1;
    }

    var currentUrl = String(window.location.href);

    if (currentUrl.indexOf('/product') != -1) {
        setTimeout(function () {
            $('.pp_variant_sel.active').trigger('click');
        }, 1000);
    }

    var firstSection = $('.ppPack').first();

    if (firstSection.hasClass('sub')) {
        var sellingPlan = $('.ppSellingPlans').val(); // Get the selected selling plan value
        $('.pp_atc_form__Sel').val(sellingPlan); // Set the value of the hidden input
    } else {
        $('.pp_atc_form__Sel').val(''); // Clear the value if `sub` is not the first
    }


    $('.ppSellingPlans').change(function () {
        var sellingPlan = $('.ppSellingPlans').val();
        $('.pp_atc_form__Sel').attr('value', sellingPlan);

        var sellingTitle = $(this).find('option:selected').html();

        $('.pp_shipping_frequency').html(sellingTitle);
    });
    //does nothing
    $('.pp_mode_sel__js').click(function () {
        $('.pp_mode_sel__js').removeClass('active');
        $(this).addClass('active');

        $('.pp_Form_prices_one').hide();
        $('.pp_Form_prices_subs').hide();

        var data = $(this).attr('data');
        console.log(data);
        var firstSection = $('.ppPack').first();

        if (firstSection.hasClass('sub')) {
            // If 'sub' is on top, set it as active
            console.log('sub');
            $('.ppPack.sub').addClass('active');
            $('.pp_mode_sel__js[data="autodelivery"]').addClass('active');
            $('.sub_delivery_selection').show();
            $('.sub_content').show();
            $('.otp_content').hide();
        } else if (firstSection.hasClass('otp')) {
            console.log('otp');
            // If 'otp' is on top, set it as active
            $('.ppPack.otp').addClass('active');
            $('.pp_mode_sel__js[data="onetime"]').addClass('active');
            $('.sub_delivery_selection').hide();
            $('.sub_content').hide();
            $('.otp_content').show();
        }

        checkPricing();
    });


    $('.pp_qty_plus').click(function () {
        var currentQty = parseFloat($('.pp_qty_val').html());
        currentQty++;
        $('.pp_qty_val').html(currentQty);
        $('.pp_atc_form__Qty').val(currentQty);
    });

    $('.pp_qty_min').click(function () {
        var currentQty = parseFloat($('.pp_qty_val').html());
        if (currentQty > 1) {
            currentQty--;
            $('.pp_qty_val').html(currentQty);
            $('.pp_atc_form__Qty').val(currentQty);
        }

    });

    $('.ppPack').click(function () {
        $('.ppPack').removeClass('active');
        $(this).addClass('active');

        var currentQty = parseFloat($(this).attr('data'));

        $('.pp_form_prices_qty_1').hide();
        $('.pp_form_prices_qty_2').hide();
        $('.pp_form_prices_qty_3').hide();
        $('.pp_form_prices_qty_' + currentQty + '').show();

        checkPricing();

        $('.pp_atc_form__Qty').attr('value', currentQty);
        if (this.classList.contains('otp')) {
            $('.ppAtcBtn').closest('.t4s-form__product').find('.pp_atc_form__Sel').attr('value', '');
        } else {
            var sellingPlan = $('.ppSellingPlans').val();
            $('.ppAtcBtn').closest('.t4s-form__product').find('.pp_atc_form__Sel').attr('value', sellingPlan);
        }

    });

    $('.pp_variant_sel').click(function () {
        $(this).closest('.pp_variant_selection').find('.pp_variant_sel').removeClass('active');
        $(this).addClass('active');

        var currentId = $(this).attr('data-id');

        if ($(this).hasClass('qz_product')) {
            $(this).closest('.qz_product_cell_content').find('.pp_default_pricing').hide();
            $(this).closest('.qz_product_cell_content').find('.pp_default_pricing[data-id="' + currentId + '"]').css('display', 'flex');

            $(this).closest('.qz_product_cell_content').find('.qz_product_card_atc').attr('data-id', currentId);
        } else {
            $('.pp_default_pricing').hide();
            $('.pp_default_pricing[data-id="' + currentId + '"]').css('display', 'flex');

            $('.pp_form_prices__js').hide();
            $('.pp_form_prices__js[data-id="' + currentId + '"]').show();

            $('.ppPackPrice_cont').hide();
            $('.ppPackPrice_cont[data-id="' + currentId + '"]').show();

            $('.pp_sku__js').hide();
            $('.pp_sku__js[data-id="' + currentId + '"]').show();

            $('.pp_square_img__js').hide();
            $('.pp_square_img__js[data-id="' + currentId + '"]').show();

            checkPricing();

            $('.pp_atc_form__Var').attr('value', currentId);

            $('.ppUpdPrice__js').hide();
            $('.ppUpdPrice__js[data-id="' + currentId + '"]').show();


            //  Updated layout
            $('.pp_bundle_price_upd').hide();
            $('.pp_bundle_price_upd[data-id="' + currentId + '"]').show();

            var currentInv = $('.pp_variant_sel.active').attr('data-inv');
            if (currentInv == '0') {
                $('.ppAtcBtn').prop('disabled', true);
                $('.ppAtcBtn').find('.text').html('Sold out');
                $('.ppAtcBtn')[0].classList.add('pp_out_of_stock');
                $('#Globo-Back-In-Stock').show();
            } else {
                $('.ppAtcBtn').prop('disabled', false);
                $('.ppAtcBtn').find('.text').html('Add to cart');
                $('.ppAtcBtn')[0].classList.remove('pp_out_of_stock');
            }
        }

        $(this).closest('.qz_product_cell').find('.qz_product_card_pricing_line').hide();
        $(this).closest('.qz_product_cell').find('.qz_product_card_pricing_line[data-id="' + currentId + '"]').show();

        $(this).closest('.qz_product_cell').find('.qz_product_card_atc').attr('data-id', currentId);

    });


    function checkPricing() {
        setTimeout(function () {

            var currentId = $('.pp_variant_sel.active').attr('data-id');
            var currentQty = parseFloat($('.ppPack.active').attr('data'));
            var dataMode = $('.ppPack.active')[0].classList.contains('sub');
            var currentPrice = parseFloat($('.pp_variant_sel[data-id="' + currentId + '"]').attr('data-price'));
            currentPrice = currentPrice * currentQty;


            if (dataMode) {
                if (currentQty == 1) {
                    currentPrice = currentPrice * 0.9;
                } else if (currentQty == 2) {
                    currentPrice = currentPrice * 0.8;
                } else if (currentQty == 3) {
                    currentPrice = currentPrice * 0.7;
                }
                $('.ppCompare').each(function () {
                    this.style.display = 'inline';
                });
            } else {
                if (currentQty == 1) {
                    currentPrice = currentPrice * 1;
                } else if (currentQty == 2) {
                    currentPrice = currentPrice * 0.9;
                } else if (currentQty == 3) {
                    currentPrice = currentPrice * 0.8;
                }
                $('.ppCompare').each(function () {
                    this.style.display = 'none';
                });
            }

            currentPrice = currentPrice / 100;

            if (currentPrice > 49) {
                $('.ppFreeShippingNote').css('opacity', '1');
                // $('.ppFreeShippingNote').html(currentPrice);
                $('.ppFeatrueShipping').show();
            } else {
                $('.ppFreeShippingNote').css('opacity', '0');
                // $('.ppFreeShippingNote').html(currentPrice);
                $('.ppFeatrueShipping').hide();
            }
            var currentPriceString = currentPrice.toFixed(2);

            $('.ppDataPrice').html('$' + currentPriceString);

        }, 50);

    }


    // Quiz popup
    $('.qz_product_popup_close').click(function () {

        $('.qz_product_popup_outer').hide();
        $('.qz_product_popup_in').css('opacity', '0');
    });

    $('.qz_product_card_view').click(function () {
        var currentId = $(this).attr('data-id');

        $('.qz_product_popup_outer[data-id="' + currentId + '"]').css('display', 'flex');
        setTimeout(function () {
            $('.qz_product_popup_in').css('opacity', '1');
        }, 800);
        $('.pp_carousel_main')[0].slick.refresh();
        $('.pp_carousel_thumb')[0].slick.refresh();

        $('.pp_Media.media_outer_cont').removeClass('loading');
    });
    $('.quantity__button').click(function () {
        var display = $(this)[0].parentElement.children[1];
        var currentQty = display.value;
        currentQty = parseFloat(currentQty);
        display.attributes[4].value = currentQty;
    });
    $('.ppAtcBtn').click(function () {


        var mainId = $(this).closest('.t4s-form__product').find('.pp_atc_form__Var').val();
        var mainQty = $(this).closest('.t4s-form__product').find('.pp_atc_form__Qty').val();
        var mainSellingPlan = $(this).closest('.t4s-form__product').find('.pp_atc_form__Sel').val();
        if (mainSellingPlan == '') {
            mainQty = $('.quantity__button')[0].parentElement.children[1].attributes[4].value;
            console.log('huzzah');
        }
        var data = {
            items: [{
                id: parseInt(mainId, 10),
                quantity: parseInt(mainQty, 10),
                selling_plan: parseInt(mainSellingPlan || null, 10),
            }]
        };
        console.log(data);

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: JSON.stringify(data),
            contentType: "application/json",
            dataType: "json",

            success: function (cart, response) {
                // refreshCartDrawer();
                // $('.cd_outer').show();
                window.location = '/cart';
                setTimeout(function () {
                    // $('.cd_outer').addClass('active');
                }, 100);
            },
            error: function (err) {
                console.log("Error:", err.responseText);
            }
        });
    });
});